import Request from './request'

export default class vehicleProfileService {
  static async find(dataFilter,token=null) {
    return new Promise(resolve => {
      Request.send({
        method: 'POST',
        path: `/VehicleProfile/advanceUser/find${token ? '?token=' + token : ''}`,
        data: {
          ...dataFilter,
        }
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(data)
        } else {
          return resolve(null)
        }
      })
    })
  }

  static async search(dataFilter) {
    return new Promise(resolve => {
      Request.send({
        method: 'POST',
        path: '/VehicleProfile/advanceUser/search',
        data: {
          ...dataFilter,
        }
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(data)
        } else {
          return resolve(null)
        }
      })
    })
  }

  static async findById(data = {},token=null) {
    return new Promise(resolve => {
      const path = token ? `/VehicleProfile/advanceUser/findById?token=${token}` : '/VehicleProfile/advanceUser/findById'
      Request.send({
        method: 'POST',
        path: path,
        data
      }).then((result = {}) => {
        const { statusCode , data} = result
        if (statusCode === 200) {
          return resolve(data)
        } else {
          return resolve(null)
        }
      })
    })
  }

  static async deleteById(data = {}) {
    return new Promise(resolve => {
      Request.send({
        method: 'POST',
        path: '/VehicleProfile/advanceUser/deleteById',
        data
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve({ isSuccess: true })
        } else {
          return resolve({ isSuccess: false })
        }
      })
    })
  }

  static async insert(data = {}) {
    return new Promise(resolve => {
      Request.send({
        method: 'POST',
        path: '/VehicleProfile/advanceUser/insert',
        data
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve({ isSuccess: true })
        } else {
          return resolve({ isSuccess: false , ...result })
        }
      })
    })
  }

  static async updateById(data = {}) {
    return new Promise(resolve => {
      Request.send({
        method: 'POST',
        path: '/VehicleProfile/advanceUser/updateById',
        data
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve({ isSuccess: true })
        } else {
          return resolve({ isSuccess: false , ...result })
        }
      })
    })
  }
}